import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Route, Switch } from "react-router-dom";
import { Redirect } from "react-router";
import DashboardContainer from "../../Containers/DashboardContainer";
import AdvisorStudents from "./AdvisorStudents";
import PlansIndex from "../Plans/PlansIndex";
import { PERSON_TYPE_VARIABLE, getPreBaseRoute, getPreBasePath, } from "../../../../components";
export const getAdvisorBasePath = () => "/app/advisor";
const getPeopleOldPath = () => "/aviso/app/advisor/students";
export const getPeoplePath = () => getAdvisorBasePath() + "/people";
const getPeopleDefaultPath = () => getPeoplePath() + "/student";
const getDashboardHomePath = () => getAdvisorBasePath() + "/home";
export const getDashboardBasePath = () => "/app/dashboard";
export const dashboardEditLink = (params) => {
    return (getPreBasePath(params === null || params === void 0 ? void 0 : params.virtualizedAppName) +
        getDashboardBasePath() +
        "/edit/" +
        params.dashboardId);
};
export const advisorHomeLink = (params) => {
    return getPreBasePath(params === null || params === void 0 ? void 0 : params.virtualizedAppName) + getDashboardHomePath();
};
export const linkToStudentWithParam = (params) => {
    return (getPreBasePath(params === null || params === void 0 ? void 0 : params.virtualizedAppName) +
        "/app/advisor/people/student" +
        params.paramString);
};
export const advisorPlansWithStatus = (params) => {
    return (getPreBasePath(params === null || params === void 0 ? void 0 : params.virtualizedAppName) +
        "/app/advisor/plans" +
        "?academicPlanStatusId=" +
        // @ts-expect-error - TS2551 - Property 'academicPlanStatusId' does not exist on type 'AcademicPlanRouteParams'. Did you mean 'academicPlanStatusid'?
        params.academicPlanStatusId);
};
export const advisorPlanWithId = (params) => {
    return (getPreBasePath(params === null || params === void 0 ? void 0 : params.virtualizedAppName) +
        "/controller/advisor/plan/" +
        params.studentAffiliationId);
};
export const studentHomePath = () => {
    return "/aviso/student/controller/student/home";
};
const AdvisorRoutes = () => (_jsxs(Switch, { children: [_jsx(Route, { component: DashboardContainer, path: getPreBaseRoute() + getDashboardHomePath() }), _jsx(Route, { path: getPreBaseRoute() + getPeoplePath() + PERSON_TYPE_VARIABLE(), component: AdvisorStudents }), _jsx(Redirect, { from: getPeopleOldPath(), to: getPreBaseRoute() + getPeopleDefaultPath() }), _jsx(Route, { path: getPreBaseRoute() + `/app/advisor/plans`, component: PlansIndex })] }));
export default AdvisorRoutes;
